import {
  Edit3,
  Smartphone,
  Phone,
  Bot,
  UserPlus,
  Globe,
  Monitor,
  MessageCircle,
  type LucideIcon,
} from "lucide-react";

/**
 * Etiquetas, iconos y colores por canal de origen de una reserva (`source`).
 * Fuente de verdad compartida entre el dashboard de reservas y la ficha 360
 * del cliente, para que la trazabilidad por canal sea consistente.
 *
 * Valores reales que produce el backend: widget, web, dashboard, phone,
 * phone-ai (IA Carmen), whatsapp-ai (bot de WhatsApp), instagram-ai y
 * messenger-ai (Carmen por Instagram y Facebook Messenger), walk-in,
 * mobile_app, google, manual.
 */
export interface SourceConfig {
  label: string;
  icon: LucideIcon;
  color: string;
  bgColor: string;
}

export const RESERVATION_SOURCE_CONFIG: Record<string, SourceConfig> = {
  widget: {
    label: "Web (widget)",
    icon: Smartphone,
    color: "text-purple-600",
    bgColor: "bg-purple-100",
  },
  web: {
    label: "Web",
    icon: Globe,
    color: "text-cyan-600",
    bgColor: "bg-cyan-100",
  },
  dashboard: {
    label: "Panel",
    icon: Edit3,
    color: "text-blue-600",
    bgColor: "bg-blue-100",
  },
  phone: {
    label: "Teléfono",
    icon: Phone,
    color: "text-green-600",
    bgColor: "bg-green-100",
  },
  "phone-ai": {
    label: "IA telefónica (Carmen)",
    icon: Bot,
    color: "text-orange-600",
    bgColor: "bg-orange-100",
  },
  "whatsapp-ai": {
    label: "WhatsApp IA",
    icon: MessageCircle,
    color: "text-teal-600",
    bgColor: "bg-teal-100",
  },
  "instagram-ai": {
    label: "Instagram IA",
    icon: MessageCircle,
    color: "text-pink-600",
    bgColor: "bg-pink-100",
  },
  "messenger-ai": {
    label: "Messenger IA",
    icon: MessageCircle,
    color: "text-blue-600",
    bgColor: "bg-blue-100",
  },
  "walk-in": {
    label: "Sin reserva (walk-in)",
    icon: UserPlus,
    color: "text-amber-600",
    bgColor: "bg-amber-100",
  },
  mobile_app: {
    label: "App móvil",
    icon: Smartphone,
    color: "text-indigo-600",
    bgColor: "bg-indigo-100",
  },
  google: {
    label: "Google",
    icon: Globe,
    color: "text-red-600",
    bgColor: "bg-red-100",
  },
  manual: {
    label: "Manual",
    icon: Monitor,
    color: "text-slate-600",
    bgColor: "bg-slate-100",
  },
};

/** Devuelve la config de un canal, con fallback al propio código. */
export function getSourceConfig(source: string): SourceConfig {
  return (
    RESERVATION_SOURCE_CONFIG[source] || {
      label: source,
      icon: Monitor,
      color: "text-gray-600",
      bgColor: "bg-gray-100",
    }
  );
}
